import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import parent from './modules/parent';
import children from './modules/children';
import timer from './modules/timer';
import game from './modules/game';
import games from './modules/games';
import gamesLogs from './modules/gamesLogs';
import gameConfig from './modules/gameConfig';
import assignments from './modules/assignments';
import classes from './modules/classes';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    socket: null,
    logInModal: {
      show: false,
      callback: null,
    },
    forgotPasswordInModal: false,
    soundOn: localStorage.getItem('soundOn'),
  },
  getters: {
    getSocket(state) {
      return state.socket;
    },
    getLogInModalState(state) {
      return state.logInModal.show;
    },
    getLogInModalCallback(state) {
      return state.logInModal.callback;
    },
    getForgotPasswordInModalState(state) {
      return state.forgotPasswordInModal;
    },
    getSoundOn(state) {
      return state.soundOn;
    },
  },
  actions: {
    setSocket({ commit }, socket) {
      commit('SET_SOCKET', socket);
    },
    setLogInModalState({ commit }, value) {
      commit('SET_LOG_IN_MODAL_STATE', value);
    },
    setLogInModalCallback({ commit }, value) {
      commit('SET_LOG_IN_MODAL_CALLBACK', value);
    },
    setForgotPasswordModalState({ commit }, value) {
      commit('SET_FORGOT_PASSWORD_IN_MODAL_STATE', value);
    },
    switchSound({ commit }, value) {
      localStorage.setItem('soundOn', value);
      commit('SET_SOUND', value);
    },
  },
  mutations: {
    SET_SOCKET(state, socket) {
      state.socket = socket;
    },
    SET_LOG_IN_MODAL_STATE(state, value) {
      state.logInModal.show = value;
    },
    SET_LOG_IN_MODAL_CALLBACK(state, value) {
      state.logInModal.callback = value;
    },
    SET_FORGOT_PASSWORD_IN_MODAL_STATE(state, value) {
      state.forgotPasswordInModal = value;
    },
    SET_SOUND(state, value) {
      state.soundOn = value;
    },
  },
  modules: {
    parent,
    timer,
    children,
    game,
    games,
    gamesLogs,
    gameConfig,
    assignments,
    classes,
  },
  plugins: [
    createPersistedState({
      paths: ['children', 'parent', 'gameConfig'],
    }),
  ],
});
